import React from "react";
import { useGlobalContext } from "../../Context/GlobalContext";
import { FaUser, FaMapMarkerAlt, FaBuilding } from "react-icons/fa";
import { MdWork, MdAdminPanelSettings } from "react-icons/md";
import LogOut from "./LogOut";

const UserInfo = () => {
  const { userData } = useGlobalContext();

  const roleColors = {
    admin: "#ef4444",
    user: "#2275f1",
    dataEntry: "#20b440",
  };

  const color = roleColors[userData?.role] || "#6b7280";

  const roleIcon =
    userData?.role === "admin" ? <MdAdminPanelSettings /> : <FaUser />;

  const formatText = (value) => {
    if (!value) return "-";

    return value
      .toString()
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="mt-2">
      <div
        className="overflow-hidden"
        style={{
          borderRadius: "14px",
          background: "#fff",
          border: "1px solid #e5e7eb",
        }}
      >
        {/* ================= PROFILE HEADER ================= */}
        <div
          className="position-relative"
          style={{
            height: "40px",
            background: `linear-gradient(135deg, ${color}, ${color}dd)`,
          }}
        >
          {/* Role */}
          <span
            className="position-absolute top-0 end-0 m-2 px-2 py-1 rounded-pill text-white fw-semibold"
            style={{
              fontSize: "9px",
              zIndex: 1,
              letterSpacing: "0.5px",
              background: "rgba(255,255,255,0.2)",
              backdropFilter: "blur(5px)",
            }}
          >
            {userData?.role?.toUpperCase()}
          </span>
        </div>

        {/* ================= PROFILE ================= */}
        <div className="px-3" style={{}}>
          <div
            className="d-flex align-items-center"
            style={{
              marginTop: "-40px",
            }}
          >
            {/* Avatar */}
            <div
              className="d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: "50px",
                zIndex: 10,
                height: "50px",
                borderRadius: "50%",
                background: "#fff",
                border: `3px solid ${color}`,
                color: color,
                fontSize: "28px",
                boxShadow: "0 3px 10px rgba(0,0,0,0.15)",
              }}
            >
              {roleIcon}
            </div>

            {/* Name */}
            <div className="ms-2 mt-4 text-truncate" style={{ zIndex: 10 }}>
              <div
                className="fw-bold text-white text-truncate"
                style={{
                  fontSize: "13px",
                  marginTop: "-3px",
                }}
              >
                {userData?.name?.toUpperCase() || "USER"}
              </div>

              <div
                className="text-muted text-truncate"
                style={{
                  fontSize: "10px",
                  maxWidth: "170px",
                }}
              >
                {formatText(userData?.desg)}
              </div>
            </div>
          </div>

          {/* ================= USER DETAILS ================= */}
          <div
            className="row g-1 "
            style={{
              fontSize: "10px",
            }}
          >
            {/* Role */}
            <div className="col-6">
              <div
                className="d-flex align-items-center p-2 h-100"
                style={{
                  borderRadius: "8px",
                  background: `${color}08`,
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 me-2"
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "7px",
                    background: `${color}18`,
                    color: color,
                  }}
                >
                  <FaUser size={10} />
                </div>

                <div className="text-truncate">
                  <div className="text-muted" style={{ fontSize: "8px" }}>
                    ROLE
                  </div>

                  <div
                    className="fw-semibold text-dark text-truncate"
                    style={{ fontSize: "10px" }}
                  >
                    {formatText(userData?.role)}
                  </div>
                </div>
              </div>
            </div>

            {/* Department */}
            <div className="col-6">
              <div
                className="d-flex align-items-center p-2 h-100"
                style={{
                  borderRadius: "8px",
                  background: `${color}08`,
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 me-2"
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "7px",
                    background: `${color}18`,
                    color: color,
                  }}
                >
                  <FaBuilding size={10} />
                </div>

                <div className="text-truncate">
                  <div className="text-muted" style={{ fontSize: "8px" }}>
                    DEPARTMENT
                  </div>

                  <div
                    className="fw-semibold text-dark text-truncate"
                    style={{ fontSize: "10px" }}
                  >
                    {formatText(userData?.dept)}
                  </div>
                </div>
              </div>
            </div>

            {/* Station */}
            <div className="col-6">
              <div
                className="d-flex align-items-center p-2 h-100"
                style={{
                  borderRadius: "8px",
                  background: `${color}08`,
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 me-2"
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "7px",
                    background: `${color}18`,
                    color: color,
                  }}
                >
                  <FaMapMarkerAlt size={10} />
                </div>

                <div className="text-truncate">
                  <div className="text-muted" style={{ fontSize: "8px" }}>
                    STATION
                  </div>

                  <div
                    className="fw-semibold text-dark text-truncate"
                    style={{ fontSize: "10px" }}
                  >
                    {formatText(userData?.stn)}
                  </div>
                </div>
              </div>
            </div>

            {/* Designation */}
            <div className="col-6">
              <div
                className="d-flex align-items-center p-2 h-100"
                style={{
                  borderRadius: "8px",
                  background: `${color}08`,
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 me-2"
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "7px",
                    background: `${color}18`,
                    color: color,
                  }}
                >
                  <MdWork size={12} />
                </div>

                <div className="text-truncate">
                  <div className="text-muted" style={{ fontSize: "8px" }}>
                    DESIGNATION
                  </div>

                  <div
                    className="fw-semibold text-dark text-truncate"
                    style={{ fontSize: "10px" }}
                  >
                    {formatText(userData?.desg)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= LOGOUT ================= */}
          <div className="mt-2 mb-2">
            <LogOut />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
